/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import '../../../vlinder.min.css';
import { useTheme } from '../../../providers/theme';
import {
  PageContainer,
  Logo,
  Heading,
  TermsText,
  SubmitButton,
  GoBackLink,
  FormComp,
  AlertComp,
  OTPComp,
  LeftContainer,
  RightContainer,
  BodyTitle,
  BodyContainer,
  ProgressBar,
  RoeSignupForm,
} from '../components';
import { useRegisterToken } from '../provider';
import { useSMRegisterPageGetContent, useSMAddRoleUser } from '../machines/';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { vappContainer } from '@/application';
import { AddRolePageService } from '../services';
import { HtmlPage as HtmlPageWidget } from '@widgets/landing-page-widget';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { Button, Form, Modal } from 'react-bootstrap';
import { Loader } from '@/components';
import { SelectInput } from '../components/FormComponent/components';
import { AppNavigatorService } from '@/AppNavigator';
import { USER_LEVEL } from '@/config/userManagement.config';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getSrv = () => {
  return vappContainer.get<AddRolePageService>(AddRolePageService.displayName);
};
const loginPageServ = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectForm, setselectForm] = useState('');
  const [activeStep, setActiveStep] = useState(0);

  const srv = getSrv();
  const _email = srv?.getUserEmail();
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const { AddRoleUserMachine, AddRoleUserSend, AddRoleUserState } =
    useSMAddRoleUser({});
  const { registerPageGetContentState } = useSMRegisterPageGetContent({});
  const [userData, setUserData] = useState<any>();
  const [whoAmI, setWhoAmI] = React.useState<string>('');
  const storageSrv = StorageModule.getInstance();

  const _sessionData = storageSrv.get('userProfile', 'session');

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };
  const getWhoAmI = async () => {
    const { whoami } = await loginPageServ()?.whoAmI();
    console.log('hifi->', whoami);
    setWhoAmI(whoami);
  };
  useEffect(() => {
    getWhoAmI();
  }, []);

  useEffect(() => {
    let token = loginPageServ()?.getToken();
    if (
      token &&
      AddRoleUserState.matches('SIGN_UP_USER_SUCCESS') &&
      AddRoleUserState?.event?.data?.value
    ) {
      toast.success('Added Successfully!');
      if (whoAmI !== '') {
        console.log('whom->', whoAmI);
        if (
          USER_LEVEL.owner.includes(whoAmI) &&
          whoAmI !== 'issuer' &&
          _sessionData?.orgRole === 'ISSUER'
        ) {
          window.open(`/profile/organization-profile`, '_self');
        } else {
          window.open(`/profile/my-profile`, '_self');
        }
      }
    }
  }, [
    AddRoleUserState.matches('SIGN_UP_USER_SUCCESS') &&
      AddRoleUserState?.event?.data?.value,
  ]);

  // useEffect(() => {
  //   if (
  //     AddRoleUserState.matches('SIGN_UP_USER_FAILED') &&
  //     AddRoleUserState?.event?.data?.value
  //   ) {
  //     toast.error(AddRoleUserState?.event?.data?.value);
  //   }
  // }, [
  //   AddRoleUserState.matches('SIGN_UP_USER_FAILED') &&
  //     AddRoleUserState?.event?.data?.value,
  // ]);

  const onRegisterSubmit = (data: any) => {
    setUserData(data);
    console.log(`register submit`, data);
    const combinedRole = data?.userType || selectForm;
    console.log('combined roles', selectForm);
    const filteredData = { ...data };
    delete filteredData.userType;
    srv?.setUserEmail(data?.email);
    console.log({
      ...filteredData,
      role: combinedRole,
      orgRole: selectForm != 'roe' ? 'BUSSINESS_ORG' : 'CARICOM_BUSSINESS_ORG',
    });
    AddRoleUserSend('START', {
      payload: {
        ...filteredData,
        role: combinedRole,
        orgRole:
          selectForm != 'roe' ? 'BUSSINESS_ORG' : 'CARICOM_BUSSINESS_ORG',
      },
    });
  };

  const onStepperClose = () => {
    props?.onCloseClick && props?.onCloseClick();
    navigate('/sign-in');
  };

  const onRefresh = () => {
    AddRoleUserSend('START', {});
  };
  const [employeetye, setEmployeeType] = useState('');
  const _renderErrors = () => {
    if (AddRoleUserState?.matches('SIGN_UP_USER_FAILED')) {
      console.log(AddRoleUserState?.event?.data?.value);
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.createProfile || {})}
          onAcknowledgement={onRefresh}
          description={[AddRoleUserState?.event?.data?.value]}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const renderSignUp = () => {
    return (
      <>
        {
          <PageContainer>
            {/* <Logo logoURL={staticPageContentConfig?.logo} /> */}
            <GoBackLink />
            <Heading title={staticPageContentConfig?.title} />
            <FormComp
              employeetype={selectForm}
              isOwner={
                userData?.userType === 'owner' ||
                userData?.userType === 'roe' ||
                selectForm === 'owner' ||
                selectForm === 'roe'
              }
              renderSubmitButton={renderSubmitButton}
              initialData={
                registerPageGetContentState?.event?.data?.value?.initialData ||
                userData ||
                {}
              }
              onFormSubmit={onRegisterSubmit}
              isPasswordField={false}
            />
            <TermsText />
          </PageContainer>
        }
        {/* <div className='d-flex justify-content-center'>
        {employeetye==='roe' && <RoeSignupForm onsubmit={onRegisterSubmit}/>}

      </div> */}
      </>
    );
  };

  const _renderSubmitButton = () => {
    return (
      <div
        className="mt-3"
        style={{ justifyContent: 'center', display: 'flex' }}
      >
        <Button
          variant="primary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '25%',
            // borderRadius: '5px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {'Next'}
        </Button>
      </div>
    );
  };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    setActiveStep(activeStep + 1);
  };

  const getDateOfBirthForm = () => {
    return (
      <div className="d-flex" style={{ width: '90%' }}>
        <LeftContainer>
          <BodyTitle
            {...(staticPageContentConfig?.bodyTitle?.selectCountry || {})}
          />
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <SelectInput
                id={'type'}
                label={'Applicant Type'}
                required={true}
                errorText={'This field is required'}
                options={[
                  {
                    id: 'prospective_employee',
                    label: 'Applicant',
                  },
                  {
                    id: 'owner',
                    label: 'Employer',
                  },
                  {
                    id: 'roe',
                    label: 'Rights Of Establishment',
                  },
                ]}
                onCompChange={(id, payload) => setselectForm(payload)}
              />
            </Form.Group>
            {_renderSubmitButton()}
          </Form>
        </LeftContainer>
        <RightContainer
          rightBlockContent={
            staticPageContentConfig?.rightBlockContent?.selectCountry
          }
        />
      </div>
    );
  };

  const _renderBody = () => {
    switch (activeStep) {
      case 0:
        return (
          <div className="d-flex justify-content-center">
            {getDateOfBirthForm()}
          </div>
        );
      case 1:
        return renderSignUp();
    }
  };

  const onActiveStepChange = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const _getPageContent = () => {
    console.log(`AddRoleUserState`, AddRoleUserState);
    if (registerPageGetContentState?.matches('RENDER_PAGE')) {
      return (
        <>
          <HtmlPageWidget
            {...staticPageContentConfig}
            headerLogo={staticPageContentConfig?.header?.headerLogo}
            // buttonItem={buttonItem}
          >
            <ProgressBar
              onActiveStepChange={onActiveStepChange}
              activeStep={activeStep}
              totalSteps={1}
              onCloseClick={onStepperClose}
              setemployeetype={setEmployeeType}
            />
            <BodyContainer>{_renderBody()}</BodyContainer>
          </HtmlPageWidget>
        </>
      );
    }
    return <></>;
  };

  if (AddRoleUserState.matches('SIGN_UP_USER')) {
    return (
      <div style={{ paddingTop: '20px' }}>
        <Loader {...(staticPageContentConfig?.loading?.registerUser || {})} />
      </div>
    );
  } else if (registerPageGetContentState?.matches('GET_PAGE_CONTENT')) {
    return (
      <Loader {...(staticPageContentConfig?.loading?.GetPageLoading || {})} />
    );
  } else {
    return (
      <>
        {_getPageContent()}
        {/* {_renderErrors()} */}
      </>
    );
  }
};
